import React from 'react';
import { List } from '@mui/material';
import { CheckMarkListItem } from '@lialo/pwa-ui/lib/BulletList';
import { useTranslation } from 'react-i18next';
import { range } from '@lialo/common/lib/array';
import { styled } from '@mui/material/styles';

interface Props {}

const StyledList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const FirstVisitorInfoList = (props: Props) => {
  const { t } = useTranslation();

  return (
    <StyledList>
      {range(1, 4).map(idx => (
        <CheckMarkListItem key={idx} title={t(`tour_detail.first_visitor_info_list.item_${idx}`)} />
      ))}
    </StyledList>
  );
};
